import React from 'react';

const N  = '#0A2540';
const E  = '#7C4DFF';
const ED = '#6030E8';

const themes = [
  { icon: '💳', title: 'Digital Financial Services',       desc: 'Mobile money, digital lending ecosystems, agent banking and financial inclusion for underserved groups.' },
  { icon: '🌍', title: 'Development Consulting',           desc: 'Donor-funded program design & implementation, multi-country coordination, impact-driven strategy.' },
  { icon: '🚀', title: 'Product & Digital Transformation', desc: 'Digital product design, banking system integration, customer experience optimization, automation.' },
  { icon: '📊', title: 'Research & Capacity Building',     desc: 'Field research, knowledge products, financial behavior insights, training & facilitation.' },
];

export default function About() {
  return (
    <section id="about" className="section" style={{ background: '#F5F7FA' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'center' }}>

          {/* Left — Text */}
          <div>
            {/* Section label — neutral navy style */}
            <div style={{
              display: 'inline-block',
              background: 'rgba(10,37,64,0.08)',
              color: N,
              border: '1px solid rgba(10,37,64,0.15)',
              padding: '4px 14px', borderRadius: 20,
              fontSize: '0.78rem', fontWeight: 700, marginBottom: 16, letterSpacing: '1px',
            }}>
              ABOUT ME
            </div>

            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 800, fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', color: N, marginBottom: 20 }}>
              Driving Impact Across{' '}
              <span style={{ color: E }}>Sub-Saharan Africa</span>
            </h2>

            <p style={{ color: '#4A5568', lineHeight: 1.9, marginBottom: 16, fontSize: '0.98rem' }}>
              I am a seasoned development professional with <strong style={{ color: N }}>5+ years' experience</strong> coordinating
              and managing multi-country projects across Sub-Saharan Africa. I specialize in project planning,
              stakeholder engagement, budgeting, and team coordination.
            </p>
            <p style={{ color: '#4A5568', lineHeight: 1.9, marginBottom: 24, fontSize: '0.98rem' }}>
              Proven track record managing donor-funded initiatives for <strong style={{ color: N }}>Mastercard Foundation,
              Gates Foundation, USAID, and UNCDF</strong> focused on youth, women, SMEs, and financial inclusion.
            </p>

            {/* Countries — navy/white style */}
            <div style={{ marginBottom: 32 }}>
              <div style={{ color: '#718096', fontSize: '0.75rem', marginBottom: 10, letterSpacing: '1px', fontWeight: 700 }}>
                COUNTRIES WORKED IN
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {['Kenya', 'Uganda', 'Tanzania', 'Zambia', 'DRC', 'Ethiopia', 'Nigeria', 'Rwanda'].map(c => (
                  <span key={c} style={{
                    background: N, color: '#fff',
                    padding: '4px 12px', borderRadius: 20,
                    fontSize: '0.78rem', fontWeight: 600,
                  }}>
                    {c}
                  </span>
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <a href="/#contact" style={{
                background: E, color: '#fff', padding: '12px 24px',
                borderRadius: 8, fontWeight: 700, fontSize: '0.9rem',
                display: 'inline-flex', alignItems: 'center', gap: 8,
                boxShadow: '0 4px 16px rgba(124,77,255,0.28)', transition: 'all 0.2s',
              }}
                onMouseEnter={e => { e.currentTarget.style.background = ED; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = E;  e.currentTarget.style.transform = 'none'; }}
              >
                <i className="fas fa-envelope" /> Contact Me
              </a>
              <a href="https://www.linkedin.com/in/denniskuria/" target="_blank" rel="noreferrer" style={{
                background: 'transparent', color: N, padding: '12px 24px',
                borderRadius: 8, fontWeight: 600, fontSize: '0.9rem',
                border: `2px solid ${N}`, display: 'inline-flex', alignItems: 'center', gap: 8, transition: 'all 0.2s',
              }}
                onMouseEnter={e => { e.currentTarget.style.background = N; e.currentTarget.style.color = '#fff'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = N; }}
              >
                <i className="fab fa-linkedin" /> LinkedIn
              </a>
            </div>
          </div>

          {/* Right — Theme cards */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {themes.map(t => (
              <div key={t.title} style={{
                background: '#fff', borderRadius: 14,
                border: '1px solid #E2E8F0', padding: 24,
                boxShadow: '0 2px 12px rgba(10,37,64,0.06)', transition: 'all 0.3s',
              }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = E; e.currentTarget.style.boxShadow = '0 8px 28px rgba(124,77,255,0.14)'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.boxShadow = '0 2px 12px rgba(10,37,64,0.06)'; e.currentTarget.style.transform = 'none'; }}
              >
                <div style={{ fontSize: '2rem', marginBottom: 12 }}>{t.icon}</div>
                <h4 style={{ color: N, fontSize: '0.95rem', marginBottom: 8, fontWeight: 700 }}>{t.title}</h4>
                <p style={{ color: '#718096', fontSize: '0.82rem', lineHeight: 1.7 }}>{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { #about .container > div { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
